import React from "react";
import { SVG, IconProps } from "../SVG";
export const SpotBattery = ({
    spotColor = "#FCB5A9",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
}: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 40 40" {...props}>
        <g clipPath="url(#Spot=on,_Size=40_svg__a)">
            <path
                fill={spotColor}
                fillRule="evenodd"
                d="M20.445 4.4c4.265.47 7.994 2.42 11.277 5.27 3.702 3.211 7.751 6.675 8.216 11.645.495 5.295-2.029 10.515-5.805 14.134-3.652 3.5-8.705 4.586-13.688 4.55-4.941-.036-10.202-.946-13.498-4.747-3.181-3.67-2.62-9.013-2.703-13.937-.084-5.062-1.216-10.827 2.23-14.426C9.93 3.282 15.56 3.862 20.445 4.4Z"
                clipRule="evenodd"
            />
            <path
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={strokeWidth}
                d="M38 23v-6M6.333 10h23.334A3.333 3.333 0 0 1 33 13.333v13.334A3.333 3.333 0 0 1 29.667 30H6.333A3.333 3.333 0 0 1 3 26.667V13.333A3.333 3.333 0 0 1 6.333 10Z"
            />
        </g>
        <defs>
            <clipPath id="Spot=on,_Size=40_svg__a">
                <path fill="#fff" d="M0 0h40v40H0z" />
            </clipPath>
        </defs>
    </SVG>
);
SpotBattery.displayName = "SpotBattery";
